import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Crown } from 'lucide-react';

const sections = [
  'Quantitative & Logical',
  'Cognitive Battery',
  'Skill & Technical',
  'Verbal & Communication',
  'Data & Abstract Reasoning',
  'Coding Fundamentals ✦',
  'Situational Judgement ✦'
];

export default function MegaCard() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/assessment/mega/verify')}
      className="mega-card group relative w-full text-left overflow-hidden rounded-3xl p-7 md:p-8 transition-all duration-300"
    >
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-yellow-400/12 via-amber-500/10 to-orange-600/12 pointer-events-none" />

      <div className="relative z-10 flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="mega-crown h-12 w-12 rounded-xl bg-gradient-to-br from-yellow-400 to-orange-600 text-white flex items-center justify-center shadow-lg shadow-amber-500/40">
            <Crown className="h-5 w-5" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-slate-900 font-cabinet">Apex All-in-One Mega Bundle</h3>
            <p className="text-sm text-slate-600">7 Sections · 70 Questions · ~75 min</p>
          </div>
        </div>

        <span className="px-3 py-1 rounded-full text-xs font-semibold bg-amber-100/85 text-amber-800 border border-amber-200">
          Best Value
        </span>
      </div>

      <p className="relative z-10 mt-4 text-sm leading-6 text-slate-700">
        The ultimate hiring-readiness battery combining aptitude, cognitive, and skill assessments plus exclusive coding fundamentals and situational judgement sections.
      </p>

      <div className="relative z-10 mt-5 flex flex-wrap gap-2">
        {sections.map((section) => (
          <span
            key={section}
            className={`text-[11px] md:text-xs px-3 py-1 rounded-full border backdrop-blur-sm ${section.includes('✦') ? 'border-amber-300/80 bg-amber-100/85 text-amber-800' : 'border-amber-200/80 bg-white/75 text-slate-700'}`}
          >
            {section}
          </span>
        ))}
      </div>

      <div className="relative z-10 mt-5">
        <div className="meg-cta-shimmer w-full rounded-xl bg-gradient-to-r from-yellow-400 via-amber-500 to-orange-600 text-slate-900 font-semibold px-4 py-3 flex items-center justify-center gap-2">
          Start Full Bundle
          <ArrowRight className="h-4 w-4" />
        </div>
      </div>
    </button>
  );
}
